/** Detect mobile browser */
export default function isMobile(ua) {
	return /\sMobile(\/\d[\d.E]+|;)?\s/.test(ua);
}
